export default "__VITE_ASSET__DICamIb7__"